module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('admin-header', {
    attrs: {
      "title": 'Locations',
      "uploader": true
    },
    on: {
      "open-filter": _vm.openFilter,
      "create-entity-request": _vm.goToNewEntityScreen,
      "entity-quick-search": _vm.search,
      "csv-upload": _vm.multiSave
    }
  }, [_c('div', {
    staticClass: "btn btn-danger sq",
    attrs: {
      "slot": "buttons",
      "data-toggle": "tooltip",
      "title": "Route Optimisation caches Locations to increase performance; click here to clear this cache following Location updates used in Optimised routes"
    },
    on: {
      "click": _vm.clearCache
    },
    slot: "buttons"
  }, [_vm._v("\n      Refresh Cache\n    ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "admin-content"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55838cae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Location/AdminLocation.vue
// module id = 2186
// module chunks = 1